import React from 'react';
import {observer} from 'mobx-react';
import TasksDirectory from './TasksDirectory';
import {offboarding} from 'main/components/tasks';

const OffboardingTasksDirectory = observer(({history}) => {
  return (
    <TasksDirectory config={offboarding} history={history}/>
  );
});

export default OffboardingTasksDirectory;

